/*
   Possible conditions:
     "cartTotalMinimum": an int amount in cents
     "cartQuantityMinimum": an int amount of items in the cart
     "productInCart": a product variant id int
     "productPropertyInCart": a product variant ID int, and a property name and value string
     
*/

class ConditionManager {
    constructor(selector, conditions, options) {
        this.selector = selector;
        this.conditions = conditions;
        this.options = options
        window.conditionManagerisRemoving = false
        this.init()
    }

    query(selector) {
        return document.querySelector(selector)
    }

    errorCheck() {
        if (this.selector === undefined) {
            throw new Error('ConditionManager: selector is undefined')
        }
        if (this.conditions === undefined) {
            throw new Error('ConditionManager: conditions is undefined')
        }

        if (!document.querySelector(this.selector)) {
            throw new Error(`ConditionManager: selector ${this.selector} does not exist`)
        }
    }

    async considerRemoval() {
        console.log('Thinking about removing');
        if (window.conditionManagerisRemoving) return;
        console.log('Not already removing');

        if (this.conditionsMet < this.options.minimumNeededConditions) {
            const item = this.query(this.selector)

            // console.log(item)
            console.log('Considering removal from cart');
            if (!item) return
            const variantId = item.dataset.variantId
            window.conditionManagerIsRemoving = true;
            try {
                console.log('Trying to remove from cart');
                await removeFromCart(variantId)
                this.removeFromLocalStorage(variantId);
                window.conditionManagerIsRemoving = false;
            } catch (error) {
                console.log(error)
                window.conditionManagerIsRemoving = false;
            }
        }
    }

    removeFromLocalStorage(id) {
        let log = localStorage.getItem("freeGiftLog");
        let logArray;

        if (!log) {
            return;
        } else {
            logArray = JSON.parse(log);
        }

        let idStr = String(id);

        const index = logArray.findIndex(element => String(element) === idStr);

        if (index > -1) {
            logArray.splice(index, 1);
        }

        localStorage.setItem("freeGiftLog", JSON.stringify(logArray));
    }

    conditionCartTotalMinimum(cartData) {
        if (cartData.total_price >= this.conditions.cartTotalMinimum) {
            return true
        }
        return false
    }

    conditionProductsInCart(cartData) {
        const cartItemIds = cartData.items.map(item => item.variant_id.toString());

        const conditionMet = this.conditions.productInCart.some(id => {
            const isInCart = cartItemIds.includes(id.toString());
            return isInCart;
        });

        return conditionMet;
    }

    multiConditionProductsInCart(cartData) {
        const cartItemIds = cartData.items.map(item => item.variant_id.toString());
        const conditionOneMet = this.conditions.multiProductsInCart.buyVariantsList1.some(id => {
            const isInCart = cartItemIds.includes(id.toString());
            return isInCart;
        });
        const conditionTwoMet = this.conditions.multiProductsInCart.buyVariantsList2.some(id => {
            const isInCart = cartItemIds.includes(id.toString());
            return isInCart;
        });

        return conditionOneMet && conditionTwoMet

    }

    conditionStategies(cartData) {
        return {
            cartTotalMinimum: () => {
                console.log('Trying cart total minimum');
                const conditionMet = this.conditionCartTotalMinimum(cartData)
                if (conditionMet) {
                    this.conditionsMet++
                } else {
                    this.considerRemoval()
                }
            },
            productInCart: () => {
                console.log('Trying product in cart');
                const conditionMet = this.conditionProductsInCart(cartData);
                if (conditionMet) {
                    this.conditionsMet++;
                } else {
                    this.considerRemoval();
                }
            },
            multiProductsInCart: () => {
                console.log('Trying multiproducts in cart');
                const conditionMet = this.multiConditionProductsInCart(cartData)
                if (conditionMet) {
                    this.conditionsMet++;
                } else {
                    this.considerRemoval();
                }
            }
        }
    }

    async checkConditions() {
        // 🚀 OPTIMIZATION: Fetch cart data once with shorter cache for responsive conditions
        console.log('🔍 ConditionManager: Fetching cart data once for all conditions');
        const cartData = await window.getCart(true, 'condition-check'); // Force refresh for accurate conditions
        
        const strategies = this.conditionStategies(cartData);
        for (let key in strategies) {
            if (this.conditions[key]) {
                strategies[key]()
            }
        }
    }

    async onInitCheck() {
        this.conditionsMet = 0
        await this.checkConditions()
    }

    initListeners() {
        const checkoutButtons = document.querySelectorAll(this.options.checkoutButtonSelector)
        checkoutButtons.forEach(button => {
            button.addEventListener('click', async (event) => {
                await this.checkConditions()
            })
        })
    }


    async init() {
        await this.onInitCheck()
        this.initListeners()
    }


}

